"use client";

import React from "react";
import { Hammer, Layers, Zap, Palette, Flame, ClipboardCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const remodelItems = [{
  id: "item-1",
  number: "01",
  title: "Room additions",
  description: "Bedrooms, family rooms and primary suites added onto your home."
}, {
  id: "item-2",
  number: "02",
  title: "Kitchen and living expansions",
  description: "Bump-outs that add space where your family needs it most."
}, {
  id: "item-3",
  number: "03",
  title: "Foundations and framing",
  description: "New footings, slab or raised foundations and framing tied into your existing structure."
}, {
  id: "item-4",
  number: "04",
  title: "Roof tie-ins",
  description: "New roof framing and roofing blended into your existing roofline."
}, {
  id: "item-5",
  number: "05",
  title: "Decks and outdoor living",
  description: "Elevated decks, patio covers and outdoor spaces built to code."
}, {
  id: "item-6",
  number: "06",
  title: "Plans, permits and engineering",
  description: "We coordinate plans, structural engineering, city plan review and inspections."
}];
const itemIcons = [Hammer, Layers, Zap, Palette, Flame, ClipboardCheck];
export default function Mastery() {
  const shouldReduceMotion = useReducedMotion();
  return <section data-section-id="91305" id="architecturecabinetrylayoutmastery" data-nav="light" className="bg-background text-foreground py-20 lg:py-28 relative overflow-hidden border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-14 lg:mb-18">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold tracking-tight text-foreground mb-4">
            What your home addition can include
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground font-sans leading-relaxed">
            One team manages every trade, from layout changes to final finishes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {remodelItems.map((item, i) => {
          const IconComponent = itemIcons[i];
          return <motion.div key={item.id} data-index={i} initial={{
            opacity: 0,
            y: shouldReduceMotion ? 0 : 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: "-50px"
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="flex">
                <Card className="flex flex-col justify-between w-full bg-card border-border border shadow-sm hover:shadow-md hover:border-foreground/25 transition-[border-color,box-shadow] rounded-xl relative p-6 sm:p-7 group">
                  <div className="absolute top-0 right-0 w-8 h-8 pointer-events-none">
                    <div className="absolute top-3 right-3 w-2.5 h-2.5 border-t border-r border-border group-hover:border-primary transition-colors" />
                  </div>

                  <div>
                    <div className="flex items-center justify-between gap-4 mb-6">
                      <div className="flex items-center justify-center size-11 rounded-lg bg-secondary text-primary border border-border group-hover:border-primary/50 transition-colors">
                        <IconComponent className="size-5" />
                      </div>
                      <span className="font-mono text-xs font-semibold tracking-wider text-muted-foreground">
                        {item.number}
                      </span>
                    </div>

                    <CardHeader className="p-0 mb-3">
                      <CardTitle className="text-lg sm:text-xl font-serif font-bold text-foreground leading-snug">
                        {item.title}
                      </CardTitle>
                    </CardHeader>

                    <CardContent className="p-0">
                      <CardDescription className="text-sm text-muted-foreground font-sans leading-relaxed">
                        {item.description}
                      </CardDescription>
                    </CardContent>
                  </div>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}